// extracted by mini-css-extract-plugin
module.exports = {"pricing":"pricing-page_pricing__VYWVQ","badge":"pricing-page_badge__FwtwB"};